import React, { useState } from "react";
import PhotoGalleryModal from "./PhotoGalleryModal";

const PhotoGalleryFooter = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const images = [
    "/images/portfolio/original-images/3col-1.jpg",
    "/images/portfolio/original-images/3col-2.jpg",
    "/images/portfolio/original-images/3col-3.jpg",
    "/images/portfolio/original-images/3col-4.jpg",
    "/images/portfolio/original-images/3col-5.jpg",
    "/images/portfolio/original-images/3col-6.jpg",
    "/images/portfolio/original-images/3col-7.jpg",
    "/images/portfolio/original-images/3col-8.jpg",
    "/images/portfolio/original-images/3col-9.jpg",
    "/images/portfolio/original-images/IMG_1696.JPG",
    "/images/portfolio/original-images/IMG_1706.JPG",
    "/images/portfolio/original-images/IMG_1715.JPG",
    "/images/portfolio/original-images/IMG_1723.JPG",
    "/images/portfolio/original-images/IMG_1733.JPG",
    "/images/portfolio/original-images/IMG_1734.JPG",
    "/images/portfolio/original-images/IMG_1741.JPG",
    "/images/portfolio/original-images/IMG_1748.JPG",
    "/images/portfolio/original-images/IMG_1762.JPG",
    "/images/portfolio/original-images/IMG_1772.JPG",
  ];

  const openModal = (index) => {
    setSelectedImageIndex(index);
    setIsModalOpen(true);
  };

  return (
    <>
      <ul className="photo-thumbs-grid">
        {images.map((img, index) => (
          <li key={index} onClick={() => openModal(index)}>
            <img src={img} alt={`Photo ${index + 1}`} />
          </li>
        ))}
      </ul>
      {isModalOpen && (
        <PhotoGalleryModal
          images={images}
          initialIndex={selectedImageIndex}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default PhotoGalleryFooter;
